import { ConstructorInterfaceActionInsert } from '../../../../interface.type'
export default function InsertActionInterface({ action }: {
    action: ConstructorInterfaceActionInsert
}) {

    return <div className='ActionInterface'>
        Insertamos en {action.table}
    </div>

}